import { MED_DATETIME_DISPLAY, formatDateTimeDisplay } from 'js/utils/DateTimeUtils';

import { getDisplayDecimalGrade } from 'bundles/author-common/utils/GradeUtils';

/**
 * renderGrade
 * returns display string given a grade
 */
export const renderGrade = (grade?: number): string => {
  return typeof grade !== 'undefined' ? getDisplayDecimalGrade(grade) + '%' : '--';
};

/**
 * renderSubmissionDate
 * Renders the submission date in a nice format.
 *
 * @param  {Number} submissionDate the timestamp
 * @return {String} a string
 */
export const renderSubmissionDate = (submissionDate: $TSFixMe) => {
  return submissionDate ? formatDateTimeDisplay(submissionDate, MED_DATETIME_DISPLAY) : '';
};

export const renderLiveOutcomeGrade = (grade: $TSFixMe) => {
  return renderGrade(grade && grade.liveOutcome && grade.liveOutcome.grade);
};
